function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M54 10c-3.628-.17-7.546-1.01-13.523 1.838-4.193 2.418-9.153 9.342-9.153 9.342C32.76 18.027 33.766 16.017 37 13c-2.396.503-6.541 1.866-7.923 3.4-3.07 3.288-3.658 6.442-3.99 10.495-.462-2.536.089-3.635.913-8.416-2.91 1.653-7.229 6.248-8 7.521-3.048 5.031-2.365 6.565-2 9.827-2.153-1.714-2-2.827-2-5.479-1.1 8.03.093 6.585.093 10.6C24.098 31.52 37 20 54 10zM14.093 40.947C17 41.305 15.962 42.06 25 40.391c-3.476-.322-5.322-.657-6-1.826 3.438.948 6.756.397 12.683-1.633 2.059-.705 4.397-2.007 7.696-4.015-4.378.17-6.772-.58-10.027-1.301 4.208-1.992 8.996-.572 11.6-2.155 2.257-1.435 3.76-2.908 6.103-5.066-3.94 2.638-7.203 2.85-10.37 2.718 0 0 8.661-3.86 12.06-7.158C52.137 17.401 54 10 54 10c-15.703 9.455-27 19.623-39.907 30.948z",
  stroke: "var(--primary-color, #000)",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M2.397 54.623C3.953 51.945 4.85 50.508 14.49 40.57",
  fill: "none",
  stroke: "var(--primary-color, #000)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgFeather = function SvgFeather(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFeather, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Feather.1e498c9a.svg";
export { ForwardRef as ReactComponent };